import { truckingConstants } from '../../_constants';
import { truckingService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const truckingActions = {
    loadTrucking,
    getTrucking,
    createTrucking,
    updateTrucking,
    deleteTrucking,
    activation,
    getAuthorizedTrucking,
    getTruckingbyBranch,
    getTruckingForTallySheet,
    TruckingForATW,
    hustlingTrucker,
    truckingForCtsreports,
    TruckingData,
}

function truckingFetched() { return { type: truckingConstants.TRUCKING_FETCHED } }
function truckingFetching() { return { type: truckingConstants.TRUCKING_FETCHING } }

function truckingSubmitted() { return { type: truckingConstants.TRUCKING_SUBMITTED } }
function truckingSubmitting() { return { type: truckingConstants.TRUCKING_SUBMITTING } }

function TruckingData() {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.TruckingData()
            .then(
                truckingData => {
                        dispatch(success(truckingData));
                        dispatch(truckingFetched());
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(truckingData) { return { type: truckingConstants.GET_TRUCKING_ALL, truckingData } }
}

function truckingForCtsreports(code) {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.truckingForCtsreports(code)
            .then(
                truckingCTSReport => {
                    dispatch(truckingFetched());
                    dispatch(success(truckingCTSReport));
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(truckingCTSReport) { return { type: truckingConstants.TRUCKING_CTS_REPORT, truckingCTSReport } }
}

function loadTrucking(skip, take, filter, search) {
    return dispatch => {
        dispatch(truckingFetching());
        dispatch(userActions.allowLeavePage());
        truckingService.loadTrucking(skip, take, filter, search)
            .then(
                truckings => {
                    if (truckings.length > 0) {
                        dispatch(success(truckings));
                        dispatch(truckingFetched());
                    } else {
                        dispatch(truckingFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(truckings) { return { type: truckingConstants.GET_TRUCKINGS, truckings } }
}
function getTrucking(code) {
    return dispatch => {
        dispatch(truckingFetching());
        dispatch(userActions.allowLeavePage());
        truckingService.getTrucking(code)
            .then(
                trucking => {
                    if (trucking.length > 0) {
                        dispatch(truckingFetched());
                        dispatch(success(trucking));
                    } else {
                        dispatch(truckingFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(trucking) { return { type: truckingConstants.GET_TRUCKING_BY_ID, trucking } }
}
function createTrucking(payload) {
    return dispatch => {
        dispatch(truckingSubmitting());
        dispatch(userActions.notallowLeavePage());
        truckingService.createTrucking(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingSubmitted());
                    dispatch(alertActions.success('Trucking added successfully'))
                    window.location.href = '/master_data/trucking';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateTrucking(payload, code) {
    return dispatch => {
        dispatch(truckingSubmitting());
        dispatch(userActions.notallowLeavePage());
        truckingService.updateTrucking(payload, code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingSubmitted());
                    dispatch(alertActions.success('Trucking updated successfully'))
                    window.location.href = '/master_data/trucking';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteTrucking(code, type) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        truckingService.deleteTrucking(code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Trucking deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/trucking';
                            break;
                        default:
                            dispatch(loadTrucking(0, 20));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    switch (type) {
                        case "specific":
                            dispatch(getTrucking(code[0]));
                            break;
                        default:
                            dispatch(loadTrucking(0, 20));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive, code) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        truckingService.activation(code, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getTrucking(id));
                    dispatch(alertActions.success(isActive ? 'Trucking activated successfully' : 'Trucking deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getTrucking(id));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getAuthorizedTrucking() {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.getAuthorizedTrucking()
            .then(
                authorizedTrucking => {
                    if (authorizedTrucking.length > 0) {
                        dispatch(success(authorizedTrucking));
                        dispatch(truckingFetched());
                    } else {
                        dispatch(truckingFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(authorizedTrucking) { return { type: truckingConstants.GET_AUTHORIZED_TRUCKING, authorizedTrucking } }
}
function getTruckingbyBranch(branch, isHauling) {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.getTruckingbyBranch(branch, isHauling)
            .then(
                truckingByBranch => {
                    dispatch(truckingFetched());
                    if (truckingByBranch.length > 0) {
                        dispatch(success(truckingByBranch));
                    } else {
                        dispatch(alertActions.warning('No Authorized Trucker on ' + branch + ' Branch'))
                    }
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(truckingByBranch) { return { type: truckingConstants.TRUCKING_BY_BRANCH, truckingByBranch } }
}
function getTruckingForTallySheet(branch, skip, take, search) {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.getTruckingForTallySheet(branch, skip, take, search)
            .then(
                TruckingForTallySheet => {
                    if (TruckingForTallySheet && TruckingForTallySheet.plateNum && TruckingForTallySheet.plateNum.length > 0) {
                        dispatch(truckingFetched());
                        dispatch(success(TruckingForTallySheet));
                    } else {
                        dispatch(truckingFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(TruckingForTallySheet) { return { type: truckingConstants.GET_TRUCKING_FOR_TALLYSHEET, TruckingForTallySheet } }
}
function TruckingForATW(branch) {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.TruckingForATW(branch)
            .then(
                truckingATW => {
                    if (truckingATW.length > 0) {
                        dispatch(truckingFetched());
                        dispatch(success(truckingATW));
                    } else {
                        dispatch(truckingFetched());
                        dispatch(alertActions.warning(truckingATW.message))
                    }
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(truckingATW) { return { type: truckingConstants.TRUCKING_FOR_ATW, truckingATW } }
}
function hustlingTrucker(branch) {
    return dispatch => {
        dispatch(truckingFetching());
        truckingService.hustlingTrucker(branch)
            .then(
                hustlingTrucker => {
                        dispatch(success(hustlingTrucker));
                        dispatch(truckingFetched());
                },
                error => {
                    dispatch(truckingFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(hustlingTrucker) { return { type: truckingConstants.TRUCKING_FOR_HUSTLING, hustlingTrucker } }
}